export default __webpack_public_path__ + "static/media/logo_min.d867de5b.png";